import PersonEdit from './PersonEdit';

export default PersonEdit;
